<script setup lang="ts">
import ArrowTop from '~icons/mdi/arrow-top'

const route = useRoute()
const { isVisible, scrollToTop } = useBackToTop()

const isCartPage = computed(() => resolvePageSection(route.path) === 'cart')
</script>

<template>
  <Transition name="back-to-top">
    <div
      v-if="isVisible"
      class="scroll-to-top d-flex justify-center d-md-block"
      :class="{ 'scroll-to-top--cart': isCartPage }"
    >
      <v-btn
        class="scroll-to-top-btn"
        variant="flat"
        elevation="0"
        rounded="pill"
        :aria-label="$t('scrollToTop')"
        data-track-id="scroll_top_button"
        @click="scrollToTop"
      >
        <v-icon :icon="ArrowTop" size="24" color="black-800" />
        <span class="scroll-to-top-btn__label d-none d-md-inline">{{ $t('scrollToTop') }}</span>
      </v-btn>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.scroll-to-top {
  position: fixed;
  z-index: 1500;
  right: 0;
  left: 0;
  bottom: 80px;
  pointer-events: none;

  @media (min-width: 960px) {
    right: 96px;
    left: auto;
    bottom: 24px;
    pointer-events: auto;
  }
}

// Cart is the only page with a sticky submit bar on the viewport bottom.
.scroll-to-top--cart {
  bottom: 136px;

  @media (min-width: 960px) {
    bottom: 88px;
  }
}

.scroll-to-top-btn {
  pointer-events: auto;
  min-width: 44px;
  min-height: 44px;
  padding-inline: 10px;
  color: rgb(var(--v-theme-black-800));
  background: rgb(255 255 255 / 72%);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(10px);
  border: 1px solid rgb(255 255 255 / 50%);
  box-shadow: 0 2px 10px rgb(0 0 0 / 10%) !important;
  transition: box-shadow 0.2s ease, background-color 0.2s ease;

  &:hover {
    background: rgb(255 255 255 / 88%);
    box-shadow: 0 4px 16px rgb(0 0 0 / 12%);
  }

  @media (min-width: 960px) {
    padding-inline: 12px;
  }
}

.scroll-to-top-btn__label {
  margin-inline-start: 8px;
}

.back-to-top-enter-active,
.back-to-top-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.back-to-top-enter-from,
.back-to-top-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@media (prefers-reduced-motion: reduce) {
  .back-to-top-enter-active,
  .back-to-top-leave-active,
  .scroll-to-top-btn {
    transition: none;
  }
}
</style>
